module.exports = __webpack_public_path__ + "static/media/Heart2_diffuse_N.e0d6de2e.jpg";